import {Banner} from './banner.js';
export class BannerApppromo extends Banner {
	
	static COUNTER_KEY = yalwa.v.cookie_name_app_promo_smart_banner;
	static IS_CLOSED_KEY = yalwa.v.cookie_name_app_promo_smart_banner_is_closed;
	constructor(component_key) {
		super(component_key);
	}
	init() {
		super.init();
	}
	show() {
		//Reset the SS
		yalwa.basics.set_cookie(BannerApppromo.IS_CLOSED_KEY, 0);
		yalwa.basics.set_cookie(BannerApppromo.COUNTER_KEY, 0);
		super.show();
	}
	
	cta_click() {
		if (yalwa.basics.is_safari()) {
			yalwa.basics.navigate(yalwa.v.ios_app_url);
		} else {
			yalwa.basics.navigate(yalwa.mobile.get_app_intent_url());
		}
	}
	close() {
		//Mark closed
		yalwa.basics.set_cookie(BannerApppromo.IS_CLOSED_KEY, 1);
		//Reset the page load counter
		yalwa.basics.set_cookie(BannerApppromo.COUNTER_KEY, 0)
		super.close();
	}
}